import React from "react";
import { Container } from "../../../../components";
import classnames from "classnames";
import Pages from "../../../../../../constants/pages";
import TEXT from "../../../text-consts";
import BackLink from "../../atoms/BackLink/BackLink";
import PersonalDetailsContinueButton from "../../organisms/PersonalDetailsContinueButton/PersonalDetailsContinueButton";
import SummaryContinueButton from "../../organisms/SummaryContinueButton/SummaryContinueButton";

interface ContinueButtonProps {
    path: string;
}

const ContinueButton: React.FC<ContinueButtonProps> = ({ path }) => {
    switch (path) {
        case Pages.ONBOARDING_B2B.URL:
        case Pages.ONBOARDING_B2B.CONTACT_INFORMATION.URL:
            return <PersonalDetailsContinueButton />;
        case Pages.ONBOARDING_B2B.SUMMARY.URL:
            return <SummaryContinueButton />;
        default:
            return null;
    }
};

interface BackButtonProps {
    path: string;
}

const BackButton: React.FC<BackButtonProps> = ({ path = "" }) => {
    let href = "";
    let text = TEXT.ONBOARDING_B2B.BUTTON.BACK;
    switch (path) {
        case Pages.ONBOARDING_B2B.RECEIPT.URL:
            href = "https://www.telia.no/";
            text = TEXT.ONBOARDING_B2B.BUTTON.TELIANO_PAGE;
            break;
        case Pages.ONBOARDING_B2B.SUBSCRIPTION_DETAILS.URL:
            href = Pages.ONBOARDING_B2B.CONTACT_INFORMATION.URL;
            text = TEXT.ONBOARDING_B2B.BUTTON.BACK;
            break;
        case Pages.ONBOARDING_B2B.SUMMARY.URL:
            href = Pages.ONBOARDING_B2B.SUBSCRIPTION_DETAILS.URL;
            text = TEXT.ONBOARDING_B2B.BUTTON.BACK;
            break;
        default:
            href = "https://www.telia.no/";
            text = TEXT.ONBOARDING_B2B.BUTTON.TELIANO_PAGE;
    }

    return <BackLink path={path} href={href} text={text} />;
};

interface ContinueSectionProps {
    className?: string;
    path: string;
}

const ContinueSection: React.FC<ContinueSectionProps> = ({ className = "", path }) => (
    <Container
        className={classnames("onboarding-b2b-page--space-between", {
            [className]: className,
        })}
        size="small"
        noMargin
    >
        <BackButton path={path} />
        <div className="onboarding-b2b-page__continue-button-container">
            <ContinueButton path={path} />
        </div>
    </Container>
);

export default ContinueSection;
